import cls from "./ButtonMenu.module.scss";
import moneyIcon from "../../assets/images/money.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const ButtonMenu = () => {
  const { count } = useSelector((state: RootState) => state.game);

  return (
    <div className={cls.menuContainer}>
      <div className={cls.counter}>
        <img alt="Money" src={moneyIcon} className={cls.moneyIcon} />
        <div>{count}</div>
      </div>
    </div>
  );
};

export default ButtonMenu;
